import React from 'react'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import style from './style'
import setComponentValues from 'helpers/fovPreview/setComponentValues'
import constrainedImageSize from 'helpers/fovPreview/constrainedImageSize'
import { FOV_PREVIEW_HEIGHT, FOV_PREVIEW_WIDTH } from 'helpers/globals'
import getCurrentCamera from 'helpers/cameras/getCurrentCamera'
import scenes from 'helpers/fovPreview/scenes'
import equals from 'ramda/src/equals'
import { fovPreviewReadyAction } from 'actions/exportActions'

const mapStateToProps = ({ cameras, ui }) => {
  return { currentCameraId: getCurrentCamera(cameras).id, showSceneSelector: EXPORT ? false : !!ui.showSceneSelector }
}

const isLargeAngle = angle => angle > 180

class FovImage extends React.Component {
  state = { ...setComponentValues({ prevState: {}, ...this.props }), isDragging: false }

  componentDidMount() {
    if (EXPORT) this.setSceneContainerImageOnLoad(this.props.scene)
  }

  componentWillReceiveProps(newProps) {
    const { streetViewActive, fovMode, horizontalAngleOfView, horizontalResolution, scene, currentCameraId,
      backgroundPosition: { backgroundPositionX, backgroundPositionY }, userUploadedSceneActive, batchUpdateCalculatorAction } = newProps

    const cameraChanged = currentCameraId !== this.props.currentCameraId

    if (fovMode !== this.props.fovMode || horizontalAngleOfView !== this.props.horizontalAngleOfView || horizontalResolution !== this.props.horizontalResolution || scene !== this.props.scene) {
      const { backgroundPosition, ...rest } = setComponentValues({ prevState: this.state, cameraChanged, ...newProps })

      this.setState({ backgroundPosition, ...rest })
      if (!cameraChanged) batchUpdateCalculatorAction({ backgroundPosition }, ['backgroundPosition'], this.props.id, false, true)
    } else if (backgroundPositionX !== this.props.backgroundPosition.backgroundPositionX || backgroundPositionY !== this.props.backgroundPosition.backgroundPositionY) {
      this.setState({ ...setComponentValues({ prevState: this.state, cameraChanged, ...newProps }) })
    }

    if ((scene !== this.props.scene || currentCameraId !== this.props.currentCameraId) && EXPORT) {
      this.setSceneContainerImageOnLoad(scene)
    }

    if (streetViewActive !== this.props.streetViewActive && streetViewActive === true && !userUploadedSceneActive && !cameraChanged) {
      const { backgroundSize: { backgroundSizeX, backgroundSizeY } } = setComponentValues({ prevState: this.state, ...newProps })
      const backgroundPosition = { backgroundPositionX: -(backgroundSizeX - FOV_PREVIEW_WIDTH) / 2, backgroundPositionY: -(backgroundSizeY - FOV_PREVIEW_HEIGHT) / 2 }

      this.setState({ backgroundPosition })
      batchUpdateCalculatorAction({ backgroundPosition }, ['backgroundPosition'], this.props.id, false)
    }
  }

  dragStart = ({ clientX, clientY }) => {
    const { backgroundPosition: { backgroundPositionX, backgroundPositionY } } = this.state
    this.dragStartX = clientX
    this.dragStartY = clientY
    this.initialBackgroundPositionX = backgroundPositionX
    this.initialBackgroundPositionY = backgroundPositionY
    this.setState({ isDragging: true })
  }

  dragging = ({ clientX, clientY }) => {
    if (!this.state.isDragging) return
    const { initialBackgroundPositionX, initialBackgroundPositionY, dragStartX, dragStartY, state: { width, height, conventional,
      clip, backgroundSize: { backgroundSizeX, backgroundSizeY } }, props: { horizontalAngleOfView, batchUpdateCalculatorAction, id } } = this
    const { backgroundPositionX, backgroundPositionY } = constrainedImageSize({
      conventional, clip, width, height,
      backgroundSize: { backgroundSizeX, backgroundSizeY },
      backgroundPosition: {
        backgroundPositionX: initialBackgroundPositionX - (dragStartX - clientX),
        backgroundPositionY: initialBackgroundPositionY - (dragStartY - clientY)
      }, horizontalAngleOfView
    })
    batchUpdateCalculatorAction({ backgroundPosition: { backgroundPositionX, backgroundPositionY } }, ['backgroundPosition'], id, false)
    this.setState({
      backgroundPosition: { backgroundPositionX, backgroundPositionY }
    })
  }

  dragEnd = _ => {
    this.setState({ isDragging: false })
  }

  setSceneContainerImageOnLoad = scene => {
    const { refs: { sceneContainer }, props: { fovPreviewReadyAction } } = this
    const image = document.createElement('img')
    const timeout = setTimeout(fovPreviewReadyAction, 5000)
    image.onerror = function() {
      this.remove()
      clearTimeout(timeout)
      fovPreviewReadyAction()
    }
    image.onload = function() {
      this.remove()
      clearTimeout(timeout)
      fovPreviewReadyAction()
    }
    const div = document.getElementById('onLoadContainer')
    div.appendChild(image)
    image.src = scene
    // start loading at the same time
    sceneContainer.style.backgroundImage = `url(${scene})`
  }

  onDragging = e => !this.state.isDragging || this.dragging(e)

  render() {
    const { onDragging, dragStart, dragEnd, state: { conventional, clip, backgroundSize: { backgroundSizeX, backgroundSizeY },
      backgroundPosition: { backgroundPositionX, backgroundPositionY } }, props: { horizontalAngleOfView, scene, showSceneSelector, classes } } = this
    return (
      <div
        className={showSceneSelector ? classes.hide : classes.container}
        style={Object.assign(
          {
            backgroundSize: `${isLargeAngle(horizontalAngleOfView) ? FOV_PREVIEW_WIDTH : backgroundSizeX}px ${isLargeAngle(horizontalAngleOfView) ? FOV_PREVIEW_HEIGHT : backgroundSizeY}px`,
            backgroundPosition: `${backgroundPositionX}px ${backgroundPositionY}px`
          },
          !EXPORT && { backgroundImage: `url(${scene})` }
        )}
        onMouseDown={dragStart}
        onMouseMove={onDragging}
        onMouseUp={dragEnd}
        ref='sceneContainer'
      >
        <div className={`${conventional ? classes.topClip : classes.rightClip} ${equals(scene, scenes['Blank']) ? classes.noBorder : ''}`} style={{ [conventional ? 'height' : 'width']: clip }} />
        <div className={`${conventional ? classes.bottomClip : classes.leftClip} ${equals(scene, scenes['Blank']) ? classes.noBorder : ''}`} style={{ [conventional ? 'height' : 'width']: clip }} />
      </div>
    )
  }
}

export default connect(mapStateToProps, { fovPreviewReadyAction })(injectSheet(style)(FovImage))



// WEBPACK FOOTER //
// ./src/components/FovPreview/FovImage/index.js